import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faExternalLinkSquare} from '@netx/core-icons';
import {canPublishAsset} from '../enablers';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionSharePublishYoutubeIcon = faExternalLinkSquare;

/**
 * Asset share publish
 * @param params
 * @returns Action
 */
export const assetActionSharePublishYoutube = (
	asset?: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-share-publish-youtube',
	cb: () => dispatcher.trigger(ASSET_EVENT.SHARE_PUBLISH_YOUTUBE, asset),
	enableTest: () => canPublishAsset(asset, 'YouTube'),
	// icon: assetActionSharePublishYoutubeIcon,
	get label() {
		return 'YouTube';
	},
	...params,
});

export default assetActionSharePublishYoutube;
